import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getToken, verifyToken } from "../lib/token";

const ProtectedRoute = ({ children, requiredRoles = null, requiredCategory = null }) => {
  const { user, userRole, loading, isAuthenticated } = useAuth();

  // Check if token exists and is valid
  const token = getToken();
  const tokenUser = token ? verifyToken(token) : null;

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If no token or token is invalid, redirect to login
  if (!token || !tokenUser || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role requirements
  if (requiredRoles) {
    const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
    if (!roles.includes(userRole)) {
      // Redirect to appropriate dashboard based on role
      if (userRole === "super_admin" || userRole === "project_admin") {
        return <Navigate to="/host-dashboard" replace />;
      } else if (userRole === "cluster_manager") {
        return <Navigate to="/cluster-dashboard" replace />;
      } else if (userRole === "worker") {
        return <Navigate to="/worker-dashboard" replace />;
      }
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Check category requirements
  if (requiredCategory) {
    if (user?.category !== requiredCategory) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
